import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';
import Input from 'components/ui/Input';

const MOCK_USER = { email: 'sarah@wininvest.com', password: 'WinGold2024!' };

export default function LoginForm({ onSwitchToRegister, onLoginSuccess }) {
  const [form, setForm] = useState({ email: '', password: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const e = {};
    if (!form?.email) e.email = 'Email is required';
    else if (!/\S+@\S+\.\S+/?.test(form?.email)) e.email = 'Invalid email address';
    if (!form?.password) e.password = 'Password is required';
    return e;
  };

  const handleSubmit = (ev) => {
    ev?.preventDefault();
    const e = validate();
    if (Object.keys(e)?.length) { setErrors(e); return; }
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      if (form?.email === MOCK_USER?.email && form?.password === MOCK_USER?.password) {
        onLoginSuccess();
      } else {
        setErrors({ general: `Invalid credentials. Use demo: ${MOCK_USER?.email} / ${MOCK_USER?.password}` });
      }
    }, 1200);
  };

  return (
    <div className="w-full">
      {/* Founding Member Banner */}
      <div className="rounded-lg p-3 mb-6 flex items-center gap-3"
        style={{ background: 'rgba(133,113,77,0.12)', border: '1px solid rgba(133,113,77,0.3)' }}>
        <Icon name="Crown" size={18} color="var(--color-accent)" />
        <span style={{ fontFamily: 'var(--font-caption)', fontSize: '0.8125rem', color: 'var(--color-foreground)' }}>
          <strong>Founding Member?</strong> Claim your exclusive badge and physical WIN coin keepsake!
        </span>
      </div>
      <h2 className="mb-1" style={{ fontFamily: 'var(--font-heading)', fontSize: '1.75rem', color: 'var(--color-foreground)' }}>
        Welcome Back
      </h2>
      <p className="mb-6" style={{ fontFamily: 'var(--font-caption)', color: 'var(--color-muted-foreground)', fontSize: '0.9rem' }}>
        Sign in to your WIN account
      </p>
      {errors?.general && (
        <div className="rounded-lg p-3 mb-4" style={{ background: 'rgba(220,38,38,0.08)', border: '1px solid rgba(220,38,38,0.3)' }}>
          <p style={{ fontFamily: 'var(--font-caption)', fontSize: '0.8125rem', color: 'var(--color-error)' }}>{errors?.general}</p>
        </div>
      )}
      <form onSubmit={handleSubmit} className="space-y-4">
        <Input label="Email Address" type="email" placeholder="sarah@example.com"
          value={form?.email} onChange={e => setForm(p => ({ ...p, email: e?.target?.value }))}
          error={errors?.email} required />
        <Input label="Password" type="password" placeholder="Enter your password"
          value={form?.password} onChange={e => setForm(p => ({ ...p, password: e?.target?.value }))}
          error={errors?.password} required />

        <div className="flex justify-end">
          <button type="button" style={{ fontFamily: 'var(--font-caption)', fontSize: '0.8125rem', color: 'var(--color-accent)', background: 'none', border: 'none', cursor: 'pointer' }}>
            Forgot password?
          </button>
        </div>

        <Button variant="default" fullWidth loading={loading} type="submit"
          className="mt-2" style={{ background: 'var(--color-accent)', color: 'var(--color-primary)' }}>
          Sign In
        </Button>
      </form>
      <div className="flex items-center gap-3 my-5">
        <div className="flex-1 h-px" style={{ background: 'var(--color-border)' }} />
        <span style={{ fontFamily: 'var(--font-caption)', fontSize: '0.8125rem', color: 'var(--color-muted-foreground)' }}>or continue with</span>
        <div className="flex-1 h-px" style={{ background: 'var(--color-border)' }} />
      </div>
      <SocialAuthButtons />
      <p className="text-center mt-6" style={{ fontFamily: 'var(--font-caption)', fontSize: '0.875rem', color: 'var(--color-muted-foreground)' }}>
        New to WIN?{' '}
        <button onClick={onSwitchToRegister} style={{ color: 'var(--color-accent)', fontWeight: 600, background: 'none', border: 'none', cursor: 'pointer' }}>
          Create your account
        </button>
      </p>
    </div>
  );
}

export function SocialAuthButtons() {
  return (
    <div className="flex flex-col gap-3">
      <button className="flex items-center justify-center gap-3 w-full rounded-lg py-3 px-4 transition-all"
        style={{ border: '1px solid var(--color-border)', background: 'var(--color-background)', fontFamily: 'var(--font-caption)', fontSize: '0.9rem', color: 'var(--color-foreground)', cursor: 'pointer' }}
        onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--color-accent)'}
        onMouseLeave={e => e.currentTarget.style.borderColor = 'var(--color-border)'}>
        <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
        Continue with Google
      </button>
      <button className="flex items-center justify-center gap-3 w-full rounded-lg py-3 px-4 transition-all"
        style={{ border: '1px solid var(--color-border)', background: 'var(--color-background)', fontFamily: 'var(--font-caption)', fontSize: '0.9rem', color: 'var(--color-foreground)', cursor: 'pointer' }}
        onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--color-accent)'}
        onMouseLeave={e => e.currentTarget.style.borderColor = 'var(--color-border)'}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
        Continue with Apple
      </button>
    </div>
  );
}